export const DASHBOARD_CONSTANTS = {
  // Page Metadata
  TITLE: 'Wedding RSVP Dashboard 💛',
  
  // Loading Screen
  LOADING: {
    EMOJI: '💫',
    TITLE: 'Loading RSVP Data...',
    DESCRIPTION: 'Gathering all the wedding responses',
  },

  // No RSVPs State
  NO_RSVPS: {
    EMOJI: '💌✨',
    TITLE: 'No RSVPs Yet',
    MESSAGE: "The wedding invitations are out there, waiting for responses! 🎉\nCheck back soon to see who's joining the celebration.",
    EMOJI_ROW: '💕 🎊 💐 🥳 💒',
  },

  // Buttons
  LOGOUT_BUTTON: 'Logout',
  EXPORT_BUTTON: '📊 Export to Excel',

  // Summary Section
  SUMMARY: {
    TITLE: 'Summary Statistics',
    TOTAL_RSVPS: 'Total RSVPs:',
    TOTAL_GUESTS: 'Total Guests:',
    PUNE_ACCOMMODATION: 'Pune Accommodation:',
    MUMBAI_ACCOMMODATION: 'Mumbai Accommodation:',
  },

  // Table Section
  TABLE: {
    TITLE: 'All RSVPs',
    SEARCH_LABEL: '🔍 Search by Name',
    SEARCH_PLACEHOLDER: "Enter a person's name...",
    SEARCH_RESULTS_PREFIX: 'Showing',
    SEARCH_RESULTS_SUFFIX: 'RSVPs',
    CLEAR_TITLE: 'Clear search',
    CLEAR_SYMBOL: '✕',
    NO_RESULTS: {
      EMOJI: '🔍',
      MESSAGE_PREFIX: 'No RSVPs found with name containing "',
      MESSAGE_SUFFIX: '"',
      TIP: 'Try searching for a different name or part of a name',
    },
  },

  // Table Headers
  HEADERS: {
    NAME: 'Name',
    EVENTS: 'Events Attending',
    GUESTS: 'Guests',
    ACCOMMODATION: 'Accommodation',
    FAVORITE_SONG: 'Dance performance?',
    PHONE: 'Phone',
    EMAIL: 'Email',
    ADDITIONAL: 'Additional Info',
    SUBMITTED: 'Submitted',
  },

  // Excel Export
  EXCEL: {
    HEADERS: {
      NAME: 'Name',
      EVENTS: 'Events Attending',
      GUESTS: 'Number of Guests',
      ACCOMMODATION: 'Need Accommodation',
      FAVORITE_SONG: 'Dance performance?',
      PHONE: 'Phone Number',
      EMAIL: 'Email Address',
      ADDITIONAL: 'Additional Info',
      SUBMITTED: 'Submitted Date',
    },
    SHEET_NAME: 'Wedding RSVPs',
    FILENAME_PREFIX: 'Wedding_RSVPs_',
  },

  // Default Values
  DEFAULT_VALUE: '-',
  UNKNOWN_DATE: 'Unknown',
  
  // Numeric Defaults
  DEFAULT_GUESTS: 0,
} as const;